<template>
  <Modal
    :model-value="modelValue"
    :title="MODAL_TITLE"
    :show-title="true"
    :show-title-icon="true"
    title-icon-type="direct"
    :show-close="true"
    :close-on-backdrop="true"
    :close-on-esc="true"
    :auto-focus="false"
    :max-width="560"
    @update:model-value="emit('update:modelValue', $event)"
  >
    <div class="platform-direct-modal text-start color-black-02">
      <div class="px-2">
        <p>
          「社内SE転職ナビ
          企業スカウト」をご利用いただくと、求人を掲載する企業と直接メッセージのやり取り、求人応募が可能です。
        </p>
        <p>
          エージェントサービスと並行してサービスをご利用することができますので、ぜひご利用ください。
        </p>
        <p>ぜひこの機会にご自身のプロフィール情報を充実させてください。</p>
        <p>プロフィール情報をもとに、企業からのスカウトが届くかもしれません。</p>
        <p>
          ご利用される場合は
          <a href="/terms" target="_blank">利用規約</a>
          をご確認・ご同意の上、利用開始してください。
        </p>
      </div>

      <p v-if="errorMessage" class="text-danger text-center mb-2 px-2" role="alert">
        {{ errorMessage }}
      </p>
      <div class="d-flex justify-content-center pt-3 pb-4">
        <button
          type="button"
          class="btn btn-primary rounded px-4 py-2 text-white size-13"
          :disabled="loading"
          @click="activateAndGoToDirectJobs()"
        >
          規約に同意して企業スカウトサービスを利用する
        </button>
      </div>
    </div>
  </Modal>
</template>

<script setup lang="ts">
import Modal from '@/components/shared/modal/Modal.vue';
import { useWelcomeGuideDirectActivation } from '@/composables/useWelcomeGuideDirectActivation';

const MODAL_TITLE = '求人掲載企業と直接やり取りをしてみませんか？';

defineProps<{
  modelValue: boolean;
}>();

defineEmits<{
  (e: 'update:modelValue', value: boolean): void;
}>();

const { loading, errorMessage, activateAndGoToDirectJobs } = useWelcomeGuideDirectActivation();
</script>
